import { render, staticRenderFns } from "./case-info-query.vue?vue&type=template&id=42418c7e&scoped=true"
import script from "./case-info-query.vue?vue&type=script&lang=ts"
export * from "./case-info-query.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42418c7e",
  null
  
)

export default component.exports